import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { createColumnQueryClient } from '@column/api';

const queryClient = createColumnQueryClient();

export const Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
